import { gql, DocumentNode } from '@apollo/client';
import React from 'react';
import MuiTipTap from '../../../../mui/MuiTipTap';
import { InvoiceStatus, InvoiceEditNotesInvoiceFragment } from '#types';

const invoiceEditNotesInvoiceFragment = gql`
	fragment invoiceEditNotesInvoice on Invoice {
		id
		notes
		status
	}
`;

export type InvoiceEditNotesProps = {
	invoice?: Omit<InvoiceEditNotesInvoiceFragment, 'id'> & { id?: string };
	setInvoice: React.Dispatch<
	React.SetStateAction<
	Omit<InvoiceEditNotesInvoiceFragment, 'id'> & { id?: string }
	>
	>;
	className?: string;
};

type InvoiceEditNotesPropsWithFragment = React.FC<InvoiceEditNotesProps> & {
	fragments: {
		invoiceEditNotesInvoiceFragment: DocumentNode;
	};
};

export const InvoiceEditNotes: InvoiceEditNotesPropsWithFragment = ( {
	invoice,
	setInvoice,
	className,
} ) => {
	const disabled = invoice?.status
		? [
			InvoiceStatus.Disputed,
			InvoiceStatus.Hidden,
			InvoiceStatus.Void,
		  ].includes( invoice.status )
		: false;

	return (
		<MuiTipTap
			className={ className }
			fullWidth
			variant='outlined'
			label='Invoice notes'
			countCharacters
			value={ invoice?.notes || '' }
			onChange={ ( notes ) =>
				setInvoice( ( prevState ) => ( {
					...prevState,
					notes: notes === '<p></p>' ? null : notes,
				} ) )
			}
			disabled={ disabled }
		/>
	);
};

InvoiceEditNotes.fragments = {
	invoiceEditNotesInvoiceFragment,
};
